import {combineReducers} from 'redux';
import Settings from './Settings';



export default (history) => combineReducers({
//  router: connectRouter(history),
  settings: Settings,
});
